import { c as _c } from "react/compiler-runtime";
import type { Entity } from '@onefootprint/request-types/dashboard';
import { Tag } from '@onefootprint/ui';
import { useTranslation } from 'react-i18next';
export type TagsProps = {
  entity: Entity;
  showFraudLabel?: boolean;
};
const Labels = t0 => {
  const $ = _c(7);
  const {
    entity: t1
  } = t0;
  const {
    watchlistCheck,
    requiresManualReview,
    hasOutstandingWorkflowRequest
  } = t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      keyPrefix: "table.row"
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const {
    t
  } = useTranslation("users", t2);
  const onWatchlist = watchlistCheck?.status === "fail";
  const showLabels = hasOutstandingWorkflowRequest || onWatchlist || requiresManualReview;
  let t3;
  if ($[1] !== hasOutstandingWorkflowRequest || $[2] !== onWatchlist || $[3] !== requiresManualReview || $[4] !== showLabels || $[5] !== t) {
    t3 = showLabels ? <div className="flex flex-wrap items-center gap-1 md:flex-nowrap">{hasOutstandingWorkflowRequest && <Tag>{t(_temp)}</Tag>}{onWatchlist && <Tag>{t(_temp2)}</Tag>}{requiresManualReview && <Tag>{t(_temp3)}</Tag>}</div> : null;
    $[1] = hasOutstandingWorkflowRequest;
    $[2] = onWatchlist;
    $[3] = requiresManualReview;
    $[4] = showLabels;
    $[5] = t;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};
export default Labels;
function _temp($) {
  return $.outstandingWorkflowRequest;
}
function _temp2($_0) {
  return $_0.onWatchlist;
}
function _temp3($_1) {
  return $_1.onReview;
}